import { Button, Table } from "react-bootstrap";

interface CategoryMember {
  pageURLId: number;
  categoryId: number;
  categoryName: string;
}

interface ListCategoryDetailProps {
  pageUrlRelationshipList: CategoryMember[];
  handelDelete: (categoryId: number, pageUrlId: number) => void;
}

const ListPageUrlDetail: React.FC<ListCategoryDetailProps> = ({
  pageUrlRelationshipList,
  handelDelete,
}) => {
  return (
    <>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>#</th>
            <th>Category</th>
          </tr>
        </thead>
        <tbody>
          {pageUrlRelationshipList.map(
            (relationship: CategoryMember, index: number) => (
              <tr key={index}>
                <td>{relationship.categoryId}</td>
                <td>{relationship.categoryName}</td>
                <td>
                  <Button
                    variant="danger"
                    onClick={() =>
                      handelDelete(
                        relationship.categoryId,
                        relationship.pageURLId
                      )
                    }
                  >
                    Delete
                  </Button>
                </td>
              </tr>
            )
          )}
        </tbody>
      </Table>
    </>
  );
};

export default ListPageUrlDetail;
